import { defineComponent as _defineComponent } from 'vue'
import { useLocalization } from '~/composables/_next/useLocalization';
import AlgoliaFrWrapper from '~/components/_next/template/recipes/AlgoliaFrWrapper.vue';
import AlgoliaEnWrapper from '~/components/_next/template/recipes/AlgoliaEnWrapper.vue';
import AlgoliaDeWrapper from '~/components/_next/template/recipes/AlgoliaDeWrapper.vue';
import AlgoliaEsWrapper from '~/components/_next/template/recipes/AlgoliaEsWrapper.vue';
import AlgoliaItWrapper from '~/components/_next/template/recipes/AlgoliaItWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlgoliaWrapper',
  setup(__props) {

const { locale } = useLocalization();

return { __sfc: true,locale, AlgoliaFrWrapper, AlgoliaEnWrapper, AlgoliaDeWrapper, AlgoliaEsWrapper, AlgoliaItWrapper }
}

})